import Cookies from 'js-cookie';
import { Observable, from, BehaviorSubject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

const TOKEN_KEY = 'auth-token';
const USER_KEY = 'auth-user';
const SESSION_KEY = 'auth-session';

export class TokenStorageService {
  constructor() {
    this.userSubject = new BehaviorSubject(this.getUserFromSession());
    this.user = this.userSubject.asObservable();
    this.tokenExpire = 30; // token expiry in days
  }

  isLoggedIn() {
    return this.userSubject.value !== null;
  }

  showPoPupLogin(){
    jconfirm({
      title: 'Confirmation !',
      content: 'You must be logged in or create an account to use this feature.',
      type: 'red',
      columnClass: 'large',
      theme: 'dark',
      buttons: {
        signup: {
            text: "Sign up",
            btnClass: 'btn-success',
            action: function () {
                window.location.href = "/register";
            }
        },
        login: {
            text: "Login",
            btnClass: 'btn-primary',
            action: function () {
                window.location.href = "/login";
            }
        },
        cancel: {
            text: "Cancel",
            btnClass: 'btn-danger float-left',
        }
      }
    });
  }

  signOut() {
    Cookies.remove(TOKEN_KEY);
    Cookies.remove(USER_KEY);
    sessionStorage.removeItem(SESSION_KEY);
    this.userSubject.next(null);
  }

  saveToken(token) {
    Cookies.set(TOKEN_KEY, token, { expires: this.tokenExpire, secure: true, path: '/', sameSite: 'Strict' });
  }

  getToken() {
    return Cookies.get(TOKEN_KEY);
  }

  saveUser(token, user) {
    this.saveSession(token, user);
    Cookies.set(USER_KEY, JSON.stringify(user), { expires: this.tokenExpire, secure: true, path: '/', sameSite: 'Strict' });
    this.saveToken(token);
    this.userSubject.next(user);
  }

  saveSession(token, user){
    axios.post('/api/session-data', {
        token: token,
        user: user
    })
    .catch(error => {
        throw new Error('Error sending session data : ' + error.response.data.message);
    });
  }

  // Function to get the current user
  getCurrentUser(): Observable<any> {
    const url = 'https://api.abyssreader.com/api/users/user/me';

    return from(axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
      }
    })).pipe(
      map(response => response.data),
      catchError(error => {
        console.error('Error fetching current user : ', error);
        throw error;
      })
    );
  }

  // create user
  createUser() {
    if (this.getToken()) {
      this.userSubject.next(this.getUserFromSession());
      return true;
    } else {
      this.userSubject.next(null);
      return false;
    }
  }

  getUser() {
    return this.userSubject.value;
  }

  getUserFromCookies() {
    const user = Cookies.get(USER_KEY);
    return user ? JSON.parse(user) : null;
  }

  getUserFromSession() {
    const user = sessionStorage.getItem(SESSION_KEY);
    return user ? JSON.parse(user) : this.getUserFromCookies();
  }
}
